import { Component, ElementRef, OnInit, ViewChild, AfterViewInit, Input } from '@angular/core';
import { match as cMath } from './canvas-circle-chart';

@Component({
    selector: 'app-canvas-circle-chart',
    templateUrl: 'canvas-circle-chart.component.html',
    styleUrls: ['canvas-circle-chart.component.scss']
})

export class CanvasCircleChartComponent implements OnInit, AfterViewInit {
    public circleStyle: any;
    public el: HTMLElement;
    @Input()
    public value: number;
    public canvasDom: any;
    public canvasInit = false;
    public showText = '0%';
    public defaults = {
        color: '#fff',
        backgroundColor: 'rgba(255,255,255,.22)',
        background: true,
        speed: 2000,
        widthRatio: 0.2,
        value: 75,
        unit: 'percent',
        counterclockwise: false,
        size: 85,
        startAngle: 75,
        animate: true,
        backgroundFix: true,
        lineCap: 'round',
        animation: 'easeInOutCubic',
        text: '',
        redraw: false,
        cAngle: 0,
        textCenter: true,
        textSize: false,
        textWeight: 'normal',
        textFamily: 'sans-serif',
        relativeTextSize: 1 / 7,
        autoCss: true,
        onDraw: false,
        currentCAngle: null,
        currentStartAngle: null
    };
    @ViewChild('circleChart', { static: true })
    public circleChart: ElementRef;
    public constructor() {
        //
    }

    public ngOnInit() {
        this.el = this.circleChart.nativeElement;
        this.canvasDom = this.circleChart.nativeElement.firstChild;
        this.defaults.value = this.value;
    }
    public ngAfterViewInit() {
        const host = this;
        this.mCircle.prototype = {
            drawBackground(ctx) {
                ctx.beginPath();
                ctx.arc(this.pos, this.pos,
                    this.settings.backgroundFix ? this.radius * 0.9999 : this.radius,
                    0, 2 * Math.PI);
                ctx.lineWidth = this.settings.backgroundFix ? this.lineWidth * 0.95 : this.lineWidth;
                ctx.shadowBlur = 1;
                ctx.shadowColor = 'rgba(0,0,0,.4)';
                ctx.strokeStyle = this.settings.backgroundColor;
                ctx.stroke();
            },
            draw(ctx) {
                ctx.beginPath();
                if (this.settings.counterclockwise) {
                    const k = 2 * Math.PI;
                    ctx.arc(this.pos, this.pos, this.radius, k - this.bAngle,
                        k - (this.bAngle + this.cAngle),
                        this.settings.counterclockwise);
                } else {
                    ctx.arc(this.pos, this.pos, this.radius, this.bAngle,
                        this.bAngle + this.cAngle,
                        this.settings.counterclockwise);
                }
                host.showText = Math.round(this.cAngle / Math.PI  / 2 * 100) + '%';
                ctx.lineWidth = this.lineWidth;
                ctx.lineCap = this.settings.lineCap;
                ctx.strokeStyle = this.settings.color;
                ctx.stroke();
            },
            animate(el, ctx, time, startTime, move/*move counterclockwise*/) {
                const rAF = ((c) => window.requestAnimationFrame || window.webkitRequestAnimationFrame ||
                    function (c) {
                        window.setTimeout(c, 1000 / 60);
                    })();
                let mspf = new Date().getTime() - time; // milliseconds per frame
                if (mspf < 1) { mspf = 1; }
                if ((time - startTime < this.settings.speed * 1.05) /* time not over */ &&
                    (!move && (this.cAngle) * 1000 <= Math.floor((this.eAngle) * 1000) /* move clockwise */ ||
                        move && (this.cAngle) * 1000 >= Math.floor((this.eAngle) * 1000)/* move counterclockwise */)) {

                    this.cAngle = cMath[this.settings.animation]((time - startTime) /
                        mspf, this.sAngle, this.eAngle - this.sAngle, this.settings.speed / mspf);
                    ctx.clearRect(0, 0, this.settings.size, this.settings.size);
                    if (this.settings.background) {
                        this.drawBackground(ctx);
                    }
                    this.draw(ctx);
                    time = new Date().getTime();
                    rAF(() => this.animate(el, ctx, time, startTime, move));
                } else {
                    this.cAngle = this.eAngle;
                    ctx.clearRect(0, 0, this.settings.size, this.settings.size);
                    if (this.settings.background) {
                        this.drawBackground(ctx);
                    }
                    this.draw(ctx);
                }
            }
        };
        this.makeCircle();
    }
    // å¨ç»
    public makeCircle() {
        const el = this.el;
        const rAF = ((call) => window.requestAnimationFrame ||
            window.webkitRequestAnimationFrame || function (call) {
                window.setTimeout(call, 1000 / 60);
            })();

        const settings = this.defaults;

        this.checkDom(settings);

        const c = this.canvasDom;
        const ctx = c.getContext('2d');

        const units = {
            percent: this.pToR,
            rad: (e) => e,
            default: this.dToR
        };

        const f = (units[settings.unit] || units.default);

        const bAngle = f(settings.startAngle);
        const eAngle = f(settings.value);
        const cAngle = f(settings.cAngle);

        const pos = settings.size / 2;
        const radius = pos * (1 - settings.widthRatio / 2);
        const lineWidth = radius * settings.widthRatio;
        const circle = this.mCircle(pos, bAngle, eAngle, cAngle, radius, lineWidth, cAngle, settings);
        // éæ­¢
        if (!settings.animate) {
            circle.cAngle = circle.eAngle;
            rAF(() => {
                ctx.clearRect(0, 0, settings.size, settings.size);
                if (settings.background) {
                    circle.drawBackground(ctx);
                }
                if (settings.value !== 0) {
                    circle.draw(ctx);
                    circle.setCurrentAnglesData(el);
                } else {
                    if (circle.settings.background) {
                        circle.drawBackground(ctx);
                    }
                }
                circle.onDraw(el);
            });
        } else {
            // å¨ç»
            if (settings.value !== 0) {
                circle.animate(el, ctx, new Date().getTime(), new Date().getTime(), cAngle > eAngle);
            } else {
                rAF(() => {
                    ctx.clearRect(0, 0, settings.size, settings.size);
                    if (circle.settings.background) {
                        circle.drawBackground(ctx);
                    }
                    circle.onDraw(el);
                });
            }
        }
    }

    public checkDom(settings) {
        // åç´ ä¸­æ²¡æcanvasæ¶å¢å ä¸ä¸ªç±»ä¸ºcircleChart_canvasçcanvas
        if (!this.canvasInit) {
            this.scaleCanvas(this.canvasDom);
            (this.el.lastElementChild as any).style.lineHeight = settings.size + 'px';
            (this.el.lastElementChild as any).style.fontSize = settings.size * settings.relativeTextSize;
            this.canvasInit = true;
        }
    }

    public mCircle = (pos, bAngle, eAngle, cAngle, radius, lineWidth, sAngle, settings) => {
        const circle = Object.create(this.mCircle.prototype);
        circle.pos = pos;
        circle.bAngle = bAngle;
        circle.eAngle = eAngle;
        circle.cAngle = cAngle;
        circle.radius = radius;
        circle.lineWidth = lineWidth;
        circle.sAngle = sAngle;
        circle.settings = settings;
        return circle;
    }

    public scaleCanvas = (c) => {
        const ctx = c.getContext('2d');
        const dpr = window.devicePixelRatio || 1;
        const bsr = ctx.webkitBackingStorePixelRatio ||
            ctx.mozBackingStorePixelRatio || ctx.msBackingStorePixelRatio ||
            ctx.oBackingStorePixelRatio || ctx.backingStorePixelRatio || 1;

        const ratio = dpr / bsr;

        const oldWidth = c.width;
        const oldHeight = c.height;
        c.width = oldWidth * ratio;
        c.height = oldHeight * ratio;

        c.style.width = oldWidth + 'px';
        c.style.height = oldHeight + 'px';

        ctx.scale(ratio, ratio);
    }

    public rToD = (rad) => rad / Math.PI * 180;
    public dToR = (deg) => deg / 180 * Math.PI;
    public pToR = (percent) => this.dToR(percent / 100 * 360);
    public rToP = (rad) => this.rToD(rad) / 360 * 100;
}
